module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAYBAMAAADwhTuyAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTP///////////////////////////////////////48EzvsAAAAKdFJOUwDAYPAv2I4IUK/PynGkAAAAQklEQVQY02NggAFRBwZUsMoETUBrMZoSJroq6RREAlZAJatQQQJDIoqKVQ5oZixCs2WVAr0VMFihKWCIQlPAwA6hALkjImYYrQhBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/section.png
// module id = MuVY
// module chunks = 1